import functions from "@/utils/functions";
import VueRouter from "vue-router";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import Vue from "vue";
import Viser from "viser-vue";
import Antd from "ant-design-vue/es";
import Print from "vue-print-nb";
import htmlToPdf from "@/utils/htmlToPdf";
import 'ant-design-vue/dist/antd.css';

import dragModal from './drag-modal';
// 导入模板配置初始化
import { initializeTemplateConfig } from '@/config/templates';

Vue.directive('drag-modal', dragModal);

Vue.config.productionTip = false;
Vue.prototype.$functions = functions;
Vue.use(VueRouter);
Vue.use(Viser);
Vue.use(Antd);
Vue.use(Print);
Vue.use(htmlToPdf);

// 模板配置将在登录成功后由路由守卫触发初始化，避免未登录时 401

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
